<template>
  <div class="measure-table">
    <el-table :data="dataList" style="width: 100%">
      <el-table-column :label="messageName" width="180" header-align="center" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.level==3">III级</span>
          <span v-if="scope.row.level==2">II级</span>
          <span v-if="scope.row.level==1">I级</span>
        </template>
      </el-table-column>
      <el-table-column label="减排量（kg）">
        <template slot-scope="scope">
          <el-input size="small" @change="changeState(`b${scope.$index}`, scope.row.ces)" placeholder="" v-model="scope.row.ces"></el-input>
        </template>
      </el-table-column>
      <el-table-column label="减排措施">
        <template slot-scope="scope">
          <el-input size="small" @change="changeState(`c${scope.$index}`, scope.row.method)" placeholder="" v-model="scope.row.method"></el-input>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dataList: [{
        level: 3,
        // name: 'III級',
        method: '',
        ces: '',
      }, {
        level: 2,
        // name: 'II級',
        method: '',
        ces: '',
      }, {
        level: 1,
        // name: 'I級',
        method: '',
        ces: '',
      }],
      formState: {},
      messageName: ''
    }
  },
  props: {
    level: {
      type: String,
      default: '等级'
    }
  },
  created() {
    this.get_data()
    this.messageName = sessionStorage.messageName
  },
  methods: {
    // 抛出数据
    get_data() {
      this.$emit('change', {
        status: this.judgeOk(),
        data: this.dataList
      })
    },

    changeState(level, data) {
      data ? this.formState[level] = true : this.formState[level] = false;
      // this.$emit('judgeisOk', this.judgeOk())
    },
    judgeOk() {
      let state = true
      let num = 0
      for (let m in this.formState) {
        if (!this.formState[m]) {
          state = false
          break;
          return
        }
        num++
      }
      return state && num == 6 ? true : false;
    }
  }
}

</script>
<style scoped>
.measure-table {
  width: 100%;
  height: auto;
  position: relative;
}

.active {
  border: 1px solid #FF4949;
  border-radius: 4px;
}

</style>



// WEBPACK FOOTER //
// measureTable.vue?53e264a4